import * as React from "react"

import gql from "graphql-tag";
import { Query } from "react-apollo";
import { getClient } from '../../../api/graphql'
import { ApolloProvider } from "react-apollo";

import { Show } from "../../pages/Show";
import { PageLoader } from "../../shared/loaders/PageLoader";



type State = {
}

type Props = {
  language_id: number
  slug: string
}

type QueryResult = {
  pages: {
    language_id: number,
    title: string,
    body: string
  }
}

type QueryVariables = {
  path: string,
  language_id: number
}

class ShowpageQuery extends Query<QueryResult, QueryVariables> { }

export default class ShowPageContainer extends React.Component<Props, State> {
  constructor(props:Props) {
    super(props)
    this.state = {
    }
  }

  render() {

    const query = gql`
      query Showpage($path:String!, $language_id:Int!) {
        pages (path: $path, languageId: $language_id) {
          languageId
          title
          identifier
          body
        }
      }
    `

    return (
      <ApolloProvider client={getClient()}>
        <ShowpageQuery
          query={query}
          variables={{
            path: this.props.slug,
            language_id: this.props.language_id,
          }}
        >
          {({ loading, error, data}) => {
            if(loading) return <PageLoader />
            if(error) return <div>Something went wrong</div>
            return (
              <Show
                title={data.pages.title}
                body={data.pages.body}
              />
            )
          }}
        </ShowpageQuery>
      </ApolloProvider>
    )
  }
}
